module.exports = __webpack_public_path__ + "img/certificate_3.959aca1c.png";